import en from '../../../components/i18nProvider/en';
import { Iprefix } from '../../../hooks/useTranslation';

const translatePrefix: Iprefix = 'programAgentRebateWallet';

export const getTabTranslatePrefix = (tab: keyof (typeof en)['programAgentRebateWallet']) =>
  (translatePrefix + '.' + tab) as Iprefix;
